const Translator = {
  get defaultLocale() {
    return process.env.VUE_APP_I18N_LOCALE;
  },
  get supportedLocales() {
    return process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
  },
  getUserSupportedLocale() {
    const userPreferredLocale = Translator.getUserLocale();

    if (Translator.isLocaleSupported(userPreferredLocale.locale)) {
      return userPreferredLocale.locale;
    }

    if (Translator.isLocaleSupported(userPreferredLocale.localeNoISO)) {
      return userPreferredLocale.localeNoISO;
    }

    return Translator.defaultLocale;
  },
  getUserLocale() {
    const locale = process.env.VUE_APP_LANGUAGE_STORAGE || window.navigator.language || Translator.defaultLocale;
    return {
      locale: locale,
      localeNoISO: locale.split('-')[0]
    };
  },
  isLocaleSupported(locale) {
    return Translator.supportedLocales.includes(locale);
  },
}

export {Translator}
